import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZippyClassDirective } from '@df/legacy/ui/zippy/zippy-class.directive';
import { ZippyCloseDirective } from '@df/legacy/ui/zippy/zippy-close.directive';
import { ZippyGroupClassDirective } from '@df/legacy/ui/zippy/zippy-group-class.directive';
import { ZippyHideUpComponent } from '@df/legacy/ui/zippy/zippy-hide-up.component';
import { ZippyOpenDirective } from '@df/legacy/ui/zippy/zippy-open.directive';
import { ZippyToggleDirective } from '@df/legacy/ui/zippy/zippy-toggle.directive';
import { ZippyDirective } from '@df/legacy/ui/zippy/zippy.directive';
import { ZippyIfDirective } from '@df/legacy/ui/zippy/zippy-if.directive';

const ASSETS = [
    ZippyDirective,
    ZippyClassDirective,
    ZippyCloseDirective,
    ZippyGroupClassDirective,
    ZippyOpenDirective,
    ZippyToggleDirective,
    ZippyHideUpComponent,
    ZippyIfDirective
];

@NgModule({
    declarations: ASSETS,
    exports: ASSETS,
    imports: [CommonModule]
})
/**
 * @deprecated Use ToggleState or direct switches
 */
export class ZippyModule {}
